import React from "react";
import PropTypes from "prop-types";

import ItemNormalLink from "./ItemNormalLink";
import ItemReactLink from "./ItemReactLink";

import css from "./MenuLink.module.scss";

/* eslint-disable react/forbid-prop-types */

const menuItemHasContent = item =>
  item.relative || (item.below || []).length > 0;

const ItemLink = ({
  item,
  className = "",
  drupalSettings = {},
  onClick = () => {}
}) => {
  if (!menuItemHasContent(item)) {
    return [];
  }
  if (!item.relative) {
    return <>{item.title}</>;
  }

  const themeConfig = drupalSettings.slnswAudioGuideTheme || {};

  // Homepage link.
  if (item.relative === "/") {
    if (themeConfig.homePage) {
      return (
        <ItemReactLink item={item} className={className} onClick={onClick} />
      );
    }
    return (
      <ItemNormalLink item={item} className={className} onClick={onClick} />
    );
  }

  // Link to podcast section.
  if (item.relative.indexOf("/podcast") === 0) {
    return (
      <ItemNormalLink item={item} className={className} onClick={onClick} />
    );
  }

  // If we have a React Audio Guide context for the current node,
  // use a React link.
  const audioGuideReactNids = (themeConfig.audioGuideNids || []).map(n =>
    parseInt(n, 10)
  );
  const audioGuideNid = parseInt(item.audio_guide_context || 0, 10);
  if (audioGuideNid > 0) {
    if (audioGuideReactNids.includes(audioGuideNid)) {
      return (
        <ItemReactLink item={item} className={className} onClick={onClick} />
      );
    }
    return (
      <ItemNormalLink item={item} className={className} onClick={onClick} />
    );
  }

  // Normal app link.
  return <ItemReactLink item={item} className={className} onClick={onClick} />;
};

ItemLink.propTypes = {
  item: PropTypes.any.isRequired,
  className: PropTypes.string,
  drupalSettings: PropTypes.any,
  onClick: PropTypes.func
};

ItemLink.defaultProps = {
  className: "",
  drupalSettings: {},
  onClick: () => {}
};

const MenuLink = ({
  item,
  depth = 0,
  className = "",
  linkClassName = "",
  drupalSettings = {},
  onClick = () => {}
}) => {
  if (item.field_css_class) {
    if ((item.field_css_class || "").includes("react-hidden")) {
      return null;
    }
  }
  let Component = "span";
  const containerClass = [];
  if (depth === 0) {
    Component = "h2";
    containerClass.push(css.level0);
  } else if (depth === 1) {
    Component = "h3";
    containerClass.push(css.level1);
  } else if (depth >= 2) {
    Component = "h4";
    containerClass.push(css.level2);
  }

  if (!menuItemHasContent(item)) {
    return [];
  }

  return (
    <Component
      className={[css.menuLink, className || ""]
        .concat(containerClass)
        .join(" ")}
    >
      <ItemLink
        item={item}
        className={linkClassName || ""}
        drupalSettings={drupalSettings}
        onClick={onClick}
      />
    </Component>
  );
};

MenuLink.propTypes = {
  item: PropTypes.any.isRequired,
  depth: PropTypes.number,
  className: PropTypes.string,
  linkClassName: PropTypes.string,
  drupalSettings: PropTypes.any,
  onClick: PropTypes.func
};

MenuLink.defaultProps = {
  depth: 0,
  className: "",
  linkClassName: "",
  drupalSettings: {},
  onClick: () => {}
};

export default MenuLink;
